import React from 'react'

import styles from './styles.module.css'

interface Props {
  url: string
  display: React.ReactNode
}

const AuthAnchorLink: React.FC<Props> = ({url, display}) => {
  return (
    <a href={url} className={styles.link}>
      {display}
    </a>
  )
}

export default AuthAnchorLink
